(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("passwordReset", function () {
        return {
            restrict: "E",
            scope: {},
            templateUrl: "app/public/passwordResetView.html",
            controllerAs: "vm",
            bindToController: true,
            controller: ["publicResource", "$state", "_", "frameworkService", "messageService", PasswordResetCtrl]
        };
        function PasswordResetCtrl(publicResource, $state, _, frameworkService, messageService) {
            var vm = this;
            vm.loading = true;
            vm.eightOrMore = false;
            vm.uppercase = false;
            vm.lowercase = false;
            vm.model = {};
            vm.token = $state.params.token;
            vm.sending = false;
            vm.frameworkData = frameworkService.data;
            publicResource.isPasswordResetTokenValid({ actionValue: vm.token }, function (result) {
                vm.valid = result.value;
                vm.loading = false;
            });
            //////////////////////////////////////
            vm.requirementsMet = function (value) {
                if (value) {
                    vm.eightOrMore = value.length >= 8;
                    vm.uppercase = value.match(/[A-Z]/) !== null;
                    vm.lowercase = value.match(/[a-z]/) !== null;
                    vm.specialCharacter = value.match(/[&+%*:.<>?]/) === null;
                }
                else {
                    clearValidation();
                }
                return vm.eightOrMore && vm.uppercase && vm.lowercase && vm.specialCharacter;
            };
            var clearValidation = function () {
                vm.eightOrMore = null;
                vm.uppercase = null;
                vm.lowercase = null;
                vm.passwordMatch = null;
            };
            vm.passwordReset = function (isFormValid) {
                if (isFormValid) {
                    vm.sending = true;
                    vm.model.tenantId = vm.frameworkData.tenant.id;
                    publicResource.passwordReset({ actionValue: vm.token }, vm.model, function () {
                        messageService.success("public.passwordReset.success");
                        $state.go("main.signIn");
                    }, function (error) {
                        messageService.error(error);
                        vm.model.password = "";
                        vm.model.confirmPassword = "";
                        clearValidation();
                        vm.showErrors = false;
                        vm.sending = false;
                    });
                }
                else {
                    vm.showErrors = true;
                }
            };
            //vm.openPrivacy = function () {
            //	$uibModal.open({
            //		templateUrl: "/app/public/privacyModalView.html",
            //		controller: "PrivacyModalCtrl as vm",
            //		size: "lg",
            //		animation: true
            //	}).result.catch(angular.noop);
            //};
        }
    });
}());
